import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import noImage from "../../../../images/noImage/noImageInfoBox.png";

const useStyles = makeStyles(theme => ({
  root: {
    width: 240,
    borderTop: props => props.title && "1px dashed #CACCD1",
    padding: "16px 0"
  },
  content: {
    display: "flex",
    alignItems: "center",
    padding: "5px 10px"
  },
  title: {
    fontSize: "10px",
    lineHeight: "12px",
    textTransform: "uppercase",
    color: "#596E79"
  },
  logo: {
    "& img": {
      width: "50px",
      height: "50px",
      border: "1px solid #CACCD1",
      boxSizing: "border-box",
      borderRadius: "75px"
    }
  },
  info: {
    "& h5": {
      fontSize: "14px",
      lineHeight: "18px",
      color: "#000000",
      paddingLeft: "15px",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    "& p": {
      fontSize: "10px",
      lineHeight: "12px",
      textTransform: "uppercase",
      color: "#596E79",
      padding: "0 15px",
      fontStyle: "normal",
      fontWeight: "normal"
    }
  }
}));

const InfoBox = ({ title, image, name, desc }) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";

  return (
    <div className={classes.root}>
      {title && <p className={classes.title}>{title}</p>}
      <div className={classes.content}>
        <div className={classes.logo}>
          {image ? (
            <img src={`${baseURL}/${image}`} alt="" />
          ) : (
            <img src={noImage} alt="" />
          )}
        </div>
        <div className={classes.info}>
          {name && <h5>{name}</h5>}
          {desc && <p>{desc}</p>}
        </div>
      </div>
    </div>
  );
};

export default InfoBox;
